import api from "!../../checkout/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../checkout/node_modules/css-loader/dist/cjs.js??clonedRuleSet-19.use[1]!../../checkout/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-19.use[2]!../../checkout/node_modules/less-loader/dist/cjs.js!./ADA.less";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};